import { render } from "./image.vue?vue&type=template&id=2805d4b2&scoped=true"
import script from "./image.vue?vue&type=script&setup=true&lang=js"
export * from "./image.vue?vue&type=script&setup=true&lang=js"

import "./image.vue?vue&type=style&index=0&id=2805d4b2&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2805d4b2"],['__file',"resources/js/components/whatsapp-managment/includes/types/image.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2805d4b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2805d4b2', __exports__)) {
    console.log('reload')
    api.reload('2805d4b2', __exports__)
  }
  
  module.hot.accept("./image.vue?vue&type=template&id=2805d4b2&scoped=true", () => {
    console.log('re-render')
    api.rerender('2805d4b2', render)
  })

}


export default __exports__